module.exports = __webpack_public_path__ + "static/media/fe.8a61c663.mp3";